import React, { useMemo } from 'react';

import PropTypes from 'prop-types';

import GroupComparisonDashboardCard from '../../CleaningReportsDashboard/GroupComparisonDashboardCard';
import { calculateEfficiency } from './EfficiencyUtils';

const EXTRA_METRICS = [
    {
        value: 'efficiency',
        labelId:
            'page.robots.cleaning_report.group_comparison.metrics.efficiency',
        unit: 'm²/min',
    },
];

export default function EfficiencyGroupComparisonCard({ data, ...rest }) {
    // Inject efficiency into data
    const enhancedData = useMemo(() => {
        if (!data) return [];
        return data.map(groupData => {
            // GroupData has tasks, time (h), area (m²)
            const eff = calculateEfficiency(
                groupData.area,
                groupData.time * 60 * 60
            );

            return {
                ...groupData,
                efficiency: eff ? Number(eff.toFixed(2)) : 0,
            };
        });
    }, [data]);

    return (
        <GroupComparisonDashboardCard
            {...rest}
            data={enhancedData}
            extraMetrics={EXTRA_METRICS}
        />
    );
}

EfficiencyGroupComparisonCard.propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({})),
};

EfficiencyGroupComparisonCard.defaultProps = {
    data: [],
};
